<template>
  <div class="main" style="height:calc(100% - 60px)!important;">
    <div class="main_header">
        <div class="header_item">
        <span class="header_label">项目名称：</span>
        <el-select v-model="search.proId" placeholder="请选择项目名称" clearable @change="ChangeLists">
            <el-option
                v-for="item in optionsProject"
                :key="item.proId"
                :label="item.proName"
                :value="item.proId">
            </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <el-button :size="size" icon="el-icon-printer" v-if="showButton('print')" @click="printClick">打印</el-button>
      </div>
    </div>
    <div class="main_content">
      <div :class="{'main_items':pitchIf !==item.pipeId,'main_items_pitch':pitchIf === item.pipeId}" v-for="(item,index) in dataList" :key="index" @click="changeItems(item)">
        <div :class="{'main_items_top':pitchIf !==item.pipeId,'main_items_top_pitch':pitchIf === item.pipeId}">
            <div class="main_item_header first_titles">
                <div class="main_item_title">环号：</div>
                <div class="main_item_datas">{{item.ringNum}}</div>
            </div>
            <div class="main_item_header">
                <div class="main_item_title">项目名称：</div>
                <div class="main_item_datas">{{item.proName}}</div>
            </div>
        </div>
        <div :class="{'main_item_contents':pitchIf !==item.pipeId,'main_item_contents_pitch':pitchIf === item.pipeId}">
            <div class="main_item_left">
                <img src="../../../assets/e.jpg" style="width:100%;height:100%">
            </div>
            <div class="main_line"></div>
            <div class="main_item_right">
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">尺寸：</div>
                    <div class="main_item_info">{{item.sizeName}}</div>
                </div>
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">注浆孔：</div>
                    <div class="main_item_info">{{item.groutingName}}个</div>
                </div>
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">配筋：</div>
                    <div class="main_item_info">{{item.reinforcementName}}</div>
                </div>
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">转向：</div>
                    <div class="main_item_info">{{item.turnName}}</div>
                </div>
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">块号：</div>
                    <div class="main_item_info">{{item.blockNumName}}</div>
                </div>
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">入模时间：</div>
                    <div class="main_item_info">{{item.intoModTime}}</div>
                </div>
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">浇筑时间：</div>
                    <div class="main_item_info">{{item.pouringTime}}</div>
                </div>
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">模具编号：</div>
                    <div class="main_item_info">{{item.mouldNum}}</div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { buttonPinia } from '../../../pinia/index';
import { changeSize } from '../../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        pitchIf:null,
        diesAllId:[],//所有管片id
        dataList: [], //管片信息打印列表
        optionsProject:[],//项目名称
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
    },
    methods: {
     //选择项目变色
     changeItems(val){
        this.pitchIf = val.pipeId
     },
     //打印按钮
     printClick(){
        if(this.pitchIf === null){
            this.$message.warning('请选择一个项目进行打印!!!')
        }
        this.$api.Print.segmentPrints({recordIds:this.diesAllId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.$message.success(res.data)
                this.pitchIf = null
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
     },
     //获得所有项目名称
     getAllProjects(){
        let obj = {
            pageNum: 1,
            pageSize: 100000000
        }
        this.$api.Engineer.searchProjects(obj).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsProject = res.data.list
                this.search.proId = res.data.list[0].proId
                this.searchButtonInfo(true)
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
     },
     //选择不同的项目进行查询
     ChangeLists(){
        this.pitchIf = null
        this.searchButtonInfo(true)
     },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.diesAllId = []
        this.$api.Print.overSegmentPrints(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
            res.data.list.forEach(item=>{
                this.diesAllId.push(item.pipeId)
            })
          }else{
            this.$message.warning(res.statusMsg)
          }
          this.loading = false;
        })
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../style/layout-main.scss';
.main_content{
    width: calc(100% - 30px);
    display: flex;
    flex-wrap: wrap;
    overflow: auto!important;

    .main_items{
        width: 100%;
        max-width: calc(100%/3 - 25px);
        height: 300px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        background-color: #26D47C;
        margin: 30px 20px 5px 5px;
        box-shadow:7px -1px 5px 9px #26D47C;

        .main_items_top{
            display: flex;
            justify-content: space-between;
            overflow: auto;
            .first_titles{
                margin-left: 10px;
                position: relative;
                &::before{
                    width: 5px;
                    height: 20px;
                    content: '';
                    position: absolute;
                    top: 2px;
                    left: 5px;
                    background-color: #fff;
                }
            }
            .main_item_header{
                padding: 0px 0px 8px 15px;
                display: flex;

                .main_item_title{
                    flex: none;
                    text-align: center;
                    font-size: 18px;
                    color: #C2F3DA;
                }
                .main_item_datas{
                    margin-right: 10px;
                    flex: none;
                    color: #fff;
                    font-size: 18px;
                }
            }
        }
        .main_item_contents{
            width: calc(100% + 11px);
            height: calc(100% - 29px);
            background-color: #2EB374;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
            display: flex;
            padding: 25px 6px;
            overflow: auto;

            .main_item_left{
                width: 260px;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0px 0px 0px 10px;
                margin-right: 10px;
            }

            .main_line{
                width: 2px;
                height: 100%;
                background-color: #2BBF8A;
            }

            .main_item_right{
                width: calc(100% - 80px);
                height: 100%;

                .main_item_right_rows{
                    display: flex;
                    justify-content: center;
                    height: 36px;
                    position: relative;

                    .main_item_rhom{
                        width: 10px;
                        height: 10px;
                        background-color: #1FEAD8; 
                        transform: roate(45deg);
                        -ms-transform:rotate(45deg);
                        -moz-transform:rotate(45deg); 
                        -webkit-transform:rotate(45deg);
                        -o-transform:rotate(45deg);
                        position: absolute;
                        top: 15px;
                        left: 15px;
                    }
                    .main_item_name{
                        width: 90px;
                        color: #F6FCF9;
                        position: absolute;
                        flex: none;
                        left: 42px;
                        font-size: 18px;
                        top: 7px;
                    }
                    .main_item_info{
                        width: 100%;
                        flex: none;
                        color: #F6FCF9;
                        position: absolute;
                        left: 132px;
                        font-size: 18px;
                        top: 9px;
                    }
                }
            }
        }
    }
    .main_items_pitch{
        width: 100%;
        max-width: calc(100%/3 - 25px);
        height: 300px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        background-color: #00D6F2;
        margin: 30px 20px 5px 5px;
        box-shadow:7px -1px 5px 9px #00D6F2;

        .main_items_top_pitch{
            display: flex;
            justify-content: space-between;
            overflow: auto;
            .first_titles{
                margin-left: 10px;
                position: relative;
                &::before{
                    width: 5px;
                    height: 20px;
                    content: '';
                    position: absolute;
                    top: 4px;
                    left: 5px;
                    background-color: #fff;
                }
            }
            .main_item_header{
                padding: 0px 0px 8px 15px;
                display: flex;
                margin-top: 4px;

                .main_item_title{
                    flex: none;
                    text-align: center;
                    font-size: 18px;
                    font-weight: 600;
                    color: #026D92;
                }
                .main_item_datas{
                    margin-right: 10px;
                    flex: none;
                    color: #093267;
                    font-weight: 550;
                    font-size: 18px;
                }
            }
        }
        .main_item_contents_pitch{
            width: calc(100% + 11px);
            height: calc(100% - 29px);
            background-color: #417BEB;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
            display: flex;
            padding: 25px 0px;
            overflow: auto;

            .main_item_left{
                width: 260px;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0px 0px 0px 10px;
                margin-right: 10px;
            }

            .main_line{
                width: 2px;
                height: 100%;
                background-color: #368BEB;
            }

            .main_item_right{
                width: calc(100% - 80px);
                height: 100%;

                .main_item_right_rows{
                    display: flex;
                    justify-content: center;
                    height: 36px;
                    position: relative;

                    .main_item_rhom{
                        width: 10px;
                        height: 10px;
                        background-color: #13BECB; 
                        transform: roate(45deg);
                        -ms-transform:rotate(45deg);
                        -moz-transform:rotate(45deg); 
                        -webkit-transform:rotate(45deg);
                        -o-transform:rotate(45deg);
                        position: absolute;
                        top: 15px;
                        left: 15px;
                    }
                    .main_item_name{
                        width: 90px;
                        color: #fff;
                        position: absolute;
                        flex: none;
                        left: 42px;
                        font-size: 18px;
                        top: 7px;
                    }
                    .main_item_info{
                        width: 100%;
                        flex: none;
                        color: #fff;
                        position: absolute;
                        left: 132px;
                        font-size: 18px;
                        top: 9px;
                    }
                }
            }
        }
    }
}

//滚动条样式
::-webkit-scrollbar {
    width: 4px; 
    height: 8px;   
}
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px #0DEAF8;
    background: rgba(0,0,0,0.2);
}
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 0;
    background: transparent;
}
</style>